import Component from '~/components/component';
import Flickity from "flickity";
import AnimRounding from '../../helpers/anim-rounding';
import PatheSlider from '../../helpers/patheSlider';

export default class SliderBox extends Component {
    constructor(...args) {
        super(...args);

        this.sliderHelper = new PatheSlider(this.dom.component)
    }

    bind() {
        this.sliderHelper.bind()
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// src/js/components/slider-box/slider-box.js